import { render, staticRenderFns } from "./kdImgVideo.vue?vue&type=template&id=6da8689b"
import script from "./kdImgVideo.vue?vue&type=script&lang=js"
export * from "./kdImgVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports